import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=9465a4c2&"
import script from "./StartView.vue?vue&type=script&lang=ts&"
export * from "./StartView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports